import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  strict: true,
  state: {
    global: {
      lang: "",
      technicalAccess: false,
      loading: false,
      accessMode: "user"
    }
  },
  getters,
  mutations,
  actions
};
